import React from 'react';
import config from 'config';
import { LoadScript, GoogleMap, Polyline } from '@react-google-maps/api';
import {
  getBounds,
  getMarker,
  getNewMarker,
  getPolyline,
} from 'services/Geolocation';

export const NewMapComponent = (props) => {
  const [currentCenter, setCurrentCenter] = React.useState(props.center);
  const [polyline, setPolyline] = React.useState([]);
  const [googleObject, setGoogleObject] = React.useState(null);
  const [polylineAttributes, setPolylineAttributes] = React.useState({});
  const [mapRef, setMapRef] = React.useState(null);

  React.useEffect(() => {
    props.bounds &&
      mapRef &&
      mapRef.fitBounds(getBounds(props.bounds, googleObject));
  }, [props.bounds, mapRef]);

  React.useEffect(() => {
    if (
      props.polyline &&
      props.polylineJourney.pickup &&
      props.polylineJourney.destination &&
      googleObject &&
      googleObject.maps
    ) {
      setPolylineAttributes(props.polylineAttributes || {});
      getPolyline(props.polylineJourney, googleObject, setPolyline);
    }
  }, [props.polylineJourney, googleObject]);
  React.useEffect(() => {
    googleObject && (props.googleRef || (() => {}))(googleObject);
  }, [googleObject]);
  React.useEffect(() => {
    mapRef && (props.googleRef || (() => {}))(mapRef);
  }, [mapRef]);

  const loadHandler = (map) => {
    setMapRef(map);
    setGoogleObject(window.google);
  };

  return (
    <LoadScript googleMapsApiKey={config.mapsAPIKey}>
      <GoogleMap
        onLoad={loadHandler}
        ref={mapRef}
        mapContainerStyle={props.containerStyle}
        clickableIcons={false}
        style={{
          ...(props.style || {}),
          padding: 0,
          margin: 0,
          position: 'absolute',
          bottom: 0,
        }}
        zoom={props.zoom || 14}
        center={props.center}
        onBoundsChanged={props.onBoundsChanged}
        options={{
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          mapTypeControl: false,
        }}
        onDragEnd={() => (props.onDragEnd || (() => {}))(currentCenter)}
        onCenterChanged={() => {
          props.centeredMarker &&
            mapRef &&
            setCurrentCenter({
              lat: mapRef.getCenter().lat(),
              lng: mapRef.getCenter().lng(),
            });
        }}
      >
        {googleObject &&
          (props.markers || []).map((marker) =>
            getNewMarker({
              ...(marker || {}),
              google: googleObject,
              ['marker']:
                marker.marker ||
                (currentCenter && {
                  location: `${currentCenter.lat},${currentCenter.lng}`,
                }) ||
                {},
            })
          )}
        <Polyline
          path={polyline}
          options={{
            strokeColor: polylineAttributes.color || '#8888ff',
            strokeOpacity: polylineAttributes.opacity || 1,
            strokeWeight: polylineAttributes.weight || 5,
          }}
        />
      </GoogleMap>
    </LoadScript>
  );
};

export default NewMapComponent;
